export function objDiff(tgt, src) {

    if (Array.isArray(tgt)) { // if you got array
        return tgt; // just copy it
    }

    // if you got object
    var rst = {};
    for (var k in tgt) { // visit all fields
        if (typeof src[k] === "object") { // if field contains object (or array because arrays are objects too)
            rst[k] = objDiff(tgt[k], src[k]); // diff the contents
        } else if (src[k] !== tgt[k]) { // if field is not an object and has changed
            rst[k] = tgt[k]; // use new value
        }
        // otherwise just skip it
    }
    return rst;
}

export function apiReady(src) {
    const nullableFields = ['comments', 'prepared_by_sign', 'attachments', 'blend_comments']
    const ignoredFields = ['attachments']
    const copySrc = {...src};
    for (var k in copySrc) {
        if (ignoredFields.indexOf(k) >= 0) {
            src[k] = null;
            continue;
        }
        if (typeof src[k] === "object") {
            src[k] = apiReady(src[k]);
        } else if (src[k] === "" && nullableFields.indexOf(k) < 0) {
            src[k] = null;
        }

    }
    return src;
}

export function convertNull2EmptyStr(src) {

    for (var k in src) {

        if (typeof src[k] === "object") {
            src[k] = convertNull2EmptyStr(src[k]);
        }
        if (src[k] === null) {
            src[k] = "";
        }

    }
    return src;
}

export const formatFileSize = (size) => {
    const units = ["B", "KB", "MB", "GB"];
    let index = 0;

    while (size >= 1024 && index < units.length - 1) {
        size /= 1024;
        index += 1;
    }

    return `${size.toFixed(2)} ${units[index]}`;
};

export function isEmpty(value) {
    return (value === null || value === '' || typeof value === 'undefined');
}

export const isNotEmpty = (value) => {

    return (value !== null && value !== undefined && value !== "")
}